import Enumerator from '../global/Enumerator';

export const messageTypes = ['email', 'sms', 'marketing_email', 'marketing_sms'];

export class MessageType extends Enumerator {
  static default() {
    return this.of('email');
  }
}

MessageType.initEnum({
  email: {
    get title() {
      return 'E-Mail';
    },
    get weight() {
      return 1;
    }
  },
  sms: {
    get title() {
      return 'SMS';
    },
    get weight() {
      return 2;
    }
  },
  marketing_email: {
    get title() {
      return 'Marketing E-Mail';
    },
    get weight() {
      return 3;
    }
  },
  marketing_sms: {
    get title() {
      return 'Marketing SMS';
    },
    get weight() {
      return 4;
    }
  }
});

export default {
  messageTypes,
  MessageType
};
